import { SHIELD_THICKNESS } from 'asteroids-shared/constants'

export function invulnerabilityAlpha(serverNow, invulnerableUntil) {
  if (!Number.isFinite(invulnerableUntil) || invulnerableUntil <= 0) return 1
  if (!Number.isFinite(serverNow) || serverNow >= invulnerableUntil) return 1
  const w = .5 + .5 * Math.sin(serverNow * .04)
  return .03 + .75 * w
}

export function drawShip(ctx, ship, camera) {
  if (!ship.alive) return;
  const shieldRadius = ship.radius + SHIELD_THICKNESS
  const visibleRadius = ship.shieldHealth > 0 ? shieldRadius : ship.radius
  camera.forEachVisibleCopy(ship.position.x, ship.position.y, visibleRadius, (sx, sy) => {
    ctx.save();
    const ga = typeof ship.globalAlpha === 'number' ? ship.globalAlpha : 1
    ctx.globalAlpha = ga
    ctx.translate(sx, sy);
    ctx.rotate(ship.rotation * Math.PI / 180);

    const thrusting = !!(ship.thrustingThisTick || ship.thrusting);
    if (thrusting) {
      ctx.strokeStyle = ship.color || '#fff';
      ctx.lineWidth = 2;
      ctx.beginPath();
      ctx.moveTo(-4, 9);
      ctx.lineTo(0, 19);
      ctx.lineTo(4, 9);
      ctx.stroke();

      ctx.strokeStyle = '#ffe066';
      ctx.beginPath();
      ctx.moveTo(-2, 9);
      ctx.lineTo(0, 15);
      ctx.lineTo(2, 9);
      ctx.stroke();
    }

    ctx.strokeStyle = ship.color || '#fff';
    ctx.fillStyle = '#000';
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.moveTo(0, -15);
    ctx.lineTo(10, 10);
    ctx.lineTo(5, 7);
    ctx.lineTo(-5, 7);
    ctx.lineTo(-10, 10);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();

    if (ship.shieldHealth > 0) {
      const flash = Number.isFinite(ship.shieldFlash) ? ship.shieldFlash : 0
      ctx.globalAlpha = ga * (0.1 + 0.1 * flash)
      ctx.strokeStyle = ship.color || '#808080'
      ctx.lineWidth = 1.5 + flash * 1.5
      ctx.beginPath()
      ctx.arc(0, 0, shieldRadius, 0, Math.PI * 2)
      ctx.stroke()
    }
    ctx.restore();
  })
}
